import { Grid, Paper } from "@mui/material";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../store";

import { IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE} from "../../../constants/signalRequestConsts";
import { getEmployeesInMyCharge, getEmployeesToApprove } from "../../../api/s10OrganizationApi";
import { searchInMyChargeEmployeesPaymentSlips, setInMyChargeEmployeePaymentSlipsReset } from "../../../store/slices/userRequests";
import TablePaymentSlips from "./TablePaymentSlips";
import MySnackbar from "../../../components/MySnackbar";
import MySelectCompany from "../../../components/MySelectCompany";

// viewType = All, InMyCharge, ToApprove

const ManagementEmployeesPaymentSlips = ({viewType}: {viewType: "All" | "InMyCharge" | "ToApprove"}) => {

    const dispatch = useDispatch<AppDispatch>();
    const {companyselected, connectionId} = useSelector((state: RootState) => state.auth);
    const [errorMsg, setErrorMsg] = useState<string>("")
    const [rucSelected, setRucSelected] = useState<string>("")

    const [employeesCodes, setEmployeesCodes] = useState<string | null>(null)
    const [descriptionOne, setDescriptionOne] = useState<string>("")
    const [pageSizeOne, setPageSizeOne] = useState<number>(25)
    const [pageOne, setPageOne] = useState<number>(2)
    const [status, setStatus] = useState<string>("-2")

    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || !connectionId) {
            return;
        }
        getInitialTablesData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rucSelected, connectionId]);

    
    useEffect(() => {
        if (!companyselected || !connectionId || !rucSelected || employeesCodes === null) {
            return;
        }
        tableOneRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [descriptionOne, pageSizeOne, pageOne, employeesCodes, rucSelected]);
    
    const getInitialTablesData = async () => {

        let _employeesCodes =  "";
        dispatch(setInMyChargeEmployeePaymentSlipsReset(IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE));
        setEmployeesCodes(null);
        const finalRuc = rucSelected === "all" ? "" : rucSelected;
        if (viewType === "InMyCharge") {
            const result = await getEmployeesInMyCharge(finalRuc);
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado en el organigrama");
                return;
            }
            _employeesCodes = result?.data.join(",")
        } else if (viewType === "ToApprove") {
            const result = await getEmployeesToApprove();
            if (!result?.data?.length) {
                setErrorMsg("No posees personal asignado a tu grupo de aprobacion")
                return;
            }
            _employeesCodes = result?.data.join(",")
        }
        setEmployeesCodes(_employeesCodes);
    }

    const tableOneRequest = () => 
        dispatch(searchInMyChargeEmployeesPaymentSlips(
            IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE,
            rucSelected,
            employeesCodes as any,
            1,
            descriptionOne,
            pageSizeOne,
            pageOne,
        ));


    return (
    <Grid item width="100%" marginTop="1.5rem" minHeight="100%">
        <Paper
            elevation={3}
            style={{
                width: "100%", 
                borderRadius: "0.5rem",
                minHeight: "10rem",
                padding: "2rem 1.5rem"
            }}
        >
            <MySelectCompany 
                setRucSelected={setRucSelected} 
                rucSelected={rucSelected}
            />
            <TablePaymentSlips 
                requestId={IN_MY_CHARGE_EMPLOYEES_PAYMENT_SLIPS_ONE}
                page={pageOne}
                setPage={setPageOne}
                description={descriptionOne}
                setDescription={setDescriptionOne}
                pageSize={pageSizeOne}
                setPageSize={setPageSizeOne}
                statusValue={status}
                setStatusValue={setStatus}
            />
        </Paper>
        {errorMsg && <MySnackbar
            msg={errorMsg}
            severity={"error"}
            open={!!errorMsg}
            onClose={() => {
                setErrorMsg("");
            }}
        />}
    </Grid>)
}

export default ManagementEmployeesPaymentSlips;